import React from "react";
import { Link } from "react-router";
import { DailyTip } from "@/features/daily/components/DailyTip";
import { StatTileVm, statTileViewModel } from "@/features/daily/components/stat-tile-view-model";

/**
 * Three fixed lines, identical in every tile of a row: the short label (full name in
 * the tooltip), the compact value (its exact figure is its accessible name and is in
 * the tooltip) and the delta with its status pill. Detail lives in the (i) tooltip —
 * hover and keyboard, Escape closes.
 */
export const StatTile: React.FC<{ tile: StatTileVm; idPrefix: string }> = ({ tile, idPrefix }) => {
    const tipId = `${idPrefix}-${tile.key}`;
    const lines = [
        tile.fullLabel,
        tile.valueExact,
        ...(tile.reference === null ? [] : [tile.reference]),
        ...(tile.flag === null ? [] : [tile.flag.label]),
        ...(tile.meta === null ? [] : [tile.meta]),
        ...tile.tooltip,
    ];
    const value = (
        <span className="daily-tile__value" data-tone={tile.valueTone} title={tile.valueExact}>
            <span className="daily-tile__compact" aria-hidden="true">{tile.value}</span>
            <span className="daily-visually-hidden">{tile.valueExact}</span>
        </span>
    );
    return (
        <li className="daily-tile" data-tone={tile.border}>
            <span className="daily-tile__line daily-tile__head">
                <span className="daily-tile__label" title={tile.fullLabel}>{tile.label}</span>
                <DailyTip id={tipId} label={`Detalle de ${tile.fullLabel}`} lines={lines} />
            </span>
            {tile.href === null ? value : (
                <Link className="daily-tile__link" to={tile.href}>{value}</Link>
            )}
            {tile.reference === null ? null : (
                <span className="daily-tile__line daily-tile__reference" title={tile.reference}>{tile.reference}</span>
            )}
            <span className="daily-tile__line daily-tile__meta">
                {tile.flag === null ? null : (
                    <span className="daily-pill daily-tile__pill" data-tone={tile.flag.tone} title={tile.flag.label}>{tile.flag.label}</span>
                )}
                {tile.meta === null ? null : <span className="daily-tile__fact" title={tile.meta}>{tile.meta}</span>}
                {tile.delta === null ? null : (
                    <span className="daily-delta" data-tone={statTileViewModel.deltaTone(tile.delta)}>
                        <span aria-hidden="true">{statTileViewModel.arrow(tile.delta.direction)}</span>
                        <span className="daily-visually-hidden">{statTileViewModel.spoken(tile.delta.direction)} </span>
                        {tile.delta.label}
                    </span>
                )}
            </span>
        </li>
    );
};
